import { render, staticRenderFns } from "./ComplaintTypeTable.vue?vue&type=template&id=7d7e5082&"
import script from "./ComplaintTypeTable.vue?vue&type=script&lang=js&"
export * from "./ComplaintTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports